var exports = {
  "zr": "IncomingCallUI.module__root___eTNjc1",
  "Nr": "IncomingCallUI.module__card___eTNjc1",
  "BU": "IncomingCallUI.module__dragHandle___eTNjc1",
  "IH": "IncomingCallUI.module__dragPill___eTNjc1",
  "t$": "IncomingCallUI.module__stack___eTNjc1",
  "wx": "IncomingCallUI.module__header___eTNjc1",
  "nr": "IncomingCallUI.module__headerIcon___eTNjc1",
  "my": "IncomingCallUI.module__avatar___eTNjc1",
  "_0": "IncomingCallUI.module__ic-ring-pulse___eTNjc1",
  "sI": "IncomingCallUI.module__callerInfo___eTNjc1",
  "XF": "IncomingCallUI.module__callerName___eTNjc1",
  "_n": "IncomingCallUI.module__callerSubtitle___eTNjc1",
  "o1": "IncomingCallUI.module__actions___eTNjc1",
  "mH": "IncomingCallUI.module__actionGroup___eTNjc1",
  "T$": "IncomingCallUI.module__circleButton___eTNjc1",
  "FM": "IncomingCallUI.module__circleButtonAccept___eTNjc1",
  "cK": "IncomingCallUI.module__circleButtonReject___eTNjc1",
  "V6": "IncomingCallUI.module__circleButtonIconRotated___eTNjc1",
  "ZJ": "IncomingCallUI.module__actionLabel___eTNjc1",
  "rw": "IncomingCallUI.module__ignoreLink___eTNjc1",
  "IR": "IncomingCallUI.module__screenReaderOnly___eTNjc1",
  "Po": "IncomingCallUI.module__bottomSheetStack___eTNjc1",
};

module.exports = exports;
